<template>
  <div class="mit-spaces-map-preview">
      <v-dialog v-model="spaceDetailsDialog" width="400">

          <v-card v-if="selectedSpace">
            <v-card-title class="text-h5 grey lighten-2">
              {{this.selectedSpace.mitIdShort + ' ' + this.selectedSpace.name }}
              <v-spacer></v-spacer>
              <v-btn text class="mx-0" fab small color="" @click="spaceDetailsDialog = false">
                  <!-- <v-icon dark>mdi-plus</v-icon> -->
                  <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
                <div class="pt-5"><b>mitId:</b> {{this.selectedSpace.mitId}}</div>
                <div><b>Organization:</b> {{this.selectedSpace.org}}</div>
                <div><b>Area (sqfoot):</b> {{this.selectedSpace.sqfoot}}</div>
                <div><b>Use Type:</b> {{this.selectedSpace.useType}}</div>
                <div><b>Use Category:</b> {{this.selectedSpace.useCategory}}</div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="spaceDetailsDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    <v-card flat>
        <v-row class="pa-0">
             <v-col cols="12" class="pa-0">
            <v-toolbar class="fixed-bar" style="width:100%;" color="grey lighten-1" elevation="2" rounded floating >
                <v-autocomplete class="pt-6" :clearable="true" dense solo :filter="autocompleteSearch" v-model="search" :items="spacesList" label="Search" item-text="mitIdShort" return-object @change="autocompleteChanged">
                   <template v-slot:item="data">
                     <template v-if="typeof data.spaceType === 'floor'">
                       <v-list-item-content v-text="'Floor '+data.level"></v-list-item-content>
                     </template>
                     <template v-else>
                       <v-list-item-avatar>
                         <v-icon>mdi-office-building-outline</v-icon>
                       </v-list-item-avatar>
                       <v-list-item-content>
                         <v-list-item-title v-html="data.item.mitIdShort"></v-list-item-title>
                         <v-list-item-subtitle v-html="data.item.useType"></v-list-item-subtitle>
                       </v-list-item-content>
                     </template>
                   </template>
               </v-autocomplete>
               <!-- <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details @change="drawMap()"></v-text-field> -->
               <v-autocomplete dense solo dense :clearable="true" class="pl-3 pt-6" label="Types" v-model="selectedType" :items="info.spaceTypes"  @change="drawMap()"></v-autocomplete>
               <v-autocomplete dense solo :clearable="true" class="pl-3 pt-6" label="Organizations" v-model="selectedOrg" :items="info.orgs" @change="drawMap()"></v-autocomplete>
               <v-select solo dense class="pl-3 pt-6 pr-10" label="Floor" :items="floors" item-text="name" item-value="val" v-model="selectedFloor" @change="drawMap()"></v-select>
               <v-spacer></v-spacer>
               <v-btn dark id="zoom_in" class="mx-2" fab small color="">
                   <!-- <v-icon dark>mdi-plus</v-icon> -->
                   <v-icon dark>mdi-magnify-plus-outline</v-icon>
               </v-btn>
               <v-btn dark id="zoom_out" class="mx-2" fab small color="">
                   <!-- <v-icon dark>mdi-minus</v-icon> -->
                   <v-icon dark>mdi-magnify-minus-outline</v-icon>
               </v-btn>
               <v-btn dark id="zoom_reset" class="mx-2" fab small color="">
                   <!-- Reset Zoom -->
                   <v-icon dark>mdi-restart</v-icon>
               </v-btn>
            </v-toolbar>
            </v-col>
        </v-row>
       <v-row>
           <v-col cols="12" >
                <v-card v-if="showAlignOption" class="toolbar-drawing-right" width="300px">
                    <v-card-title>Align Structure</v-card-title>
                    <v-card-text>
                        <v-row no-gutters>
                            <v-text-field label="Angle" type="number" step="0.1" min="-360" max="360" v-model="alignOverride.angle"></v-text-field>
                        </v-row>
                        <v-row no-gutters>
                            <v-col>
                                <v-row no-gutters>
                                    <v-btn class="mx-2 ml-10" fab small color="primary" @click="alignOverride.y+=1"><v-icon dark>mdi-arrow-up-bold</v-icon></v-btn>
                                </v-row>
                                <v-row no-gutters>
                                    <v-btn class="mx-2 mr-5" fab small color="primary" @click="alignOverride.x-=1"><v-icon dark>mdi-arrow-left-bold</v-icon></v-btn>
                                    <v-btn class="mx-2" fab small color="primary" @click="alignOverride.x+=1"><v-icon dark>mdi-arrow-right-bold</v-icon></v-btn>
                                </v-row>
                                <v-row no-gutters>
                                    <v-btn class="mx-2 ml-10" fab small color="primary" @click="alignOverride.y-=1"><v-icon dark>mdi-arrow-down-bold</v-icon></v-btn>
                                </v-row>
                            </v-col>
                            <v-col>
                                <v-text-field v-model.number="alignOverride.x" type="number" label="Offset X"></v-text-field>
                                <v-text-field v-model.number="alignOverride.y" type="number" label="Offset Y"></v-text-field>
                            </v-col>
                        </v-row>
                        
                        <v-row no-gutters class="pt-10">
                            <v-spacer/><v-btn @click="adjust()">Update</v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            <!-- </div>
            </div> -->
            
           
               <!-- <div style="border-style: solid; border-width: 1px; border-color: gray;" class="scrollable"> -->
               <div class="scrollable pa-0">
                   <svg id="mit-svg" ></svg>
               </div>
           </v-col>
       </v-row>
     </v-card>
  </div>
</template>

<script>
/*
DRAWING examples
https://stackoverflow.com/questions/10884886/d3js-how-to-get-lat-log-geocoordinates-from-mouse-click
http://jsfiddle.net/9tr7w/360/
*/
import * as d3 from "d3";

import MitMapPreviewService from '../services/MitMapPreviewService.js';


export default {
  name: 'MitSpacesMapPreview',
  components: {
  },
  props: {
      showAlignOption:{
        default() {
            return false
          },
          type:Boolean
      },
      alignOverride:{
        default() {
            return {
                angle:-24.7,
                x:766224.01,
                y:2957068.4,
            }
          },
          type:Object
      },
      defaultLevel:{
        default() {
            return null
          },
          type:Number
      },
      enabledFeatures:{
          default() {
            return {
                addObject:false,
                moveObject:false,
                viewObjects:true,
                showSearch:true,
                showSearchTypes:true,
                showSearchOrgs:true,
                showZoom:true
            }
          },
          type:Object
      },
      spacesList:{
          default:[],
          type:Array
      },
      mapGeoJson:{
          default:{},
          type:Object
      },
      info:{
          default:{
              levels:[],
              spaceTypes:[],
              spaceUses:[],
              orgs:[]
          },
          type:Object
      }
  },
  data: function() {
    return {
        spaceDetailsDialog:false,
        floors:[],
        selectedFloor:1,
        selectedType:null,
        selectedOrg:'COMP SCI & AI LAB',
        selectedSpace:null,
        palletObjectSelected:null,
        palletObjects:[
                    {
                        id:'printer',
                        width:10,
                        height:10,
                        imagePath:'/assets/objects/printer.png',
                        icon:'mdi-printer',
                        name:'Printer'
                    },
                    {
                        id:'phonebooth',
                        width:10,
                        height:10,
                        imagePath:'/assets/objects/phonebooth.png',
                        icon:'mdi-card-account-phone',
                        name:'Phonebooth'
                    }
                ],
        svg:null,
        size:{
            w:1000,
            h:800
        },
        zoom:null,
        search:null,
        mapSpaceSelected:'',
        colorCodes:{
            BACKGROUND:'#DDC7A8',
            GREY:'#838382',
            'CORRIDOR':'#DDC7A8',
            'STAIRWAY':'#838382',
            'ELEVATOR':'#838382'
        },
        mapService:null
    }
  },
  created() {

  },
  mounted() {
      for(let x = 0; x < this.info.levels.length; x++){
         this.floors.push({name:'Floor '+this.info.levels[x], val:parseInt(this.info.levels[x])});
      }
      if(this.floors.length > 3){
          this.selectedFloor = this.floors[2].val;
      }
      if(this.defaultLevel != null){
        this.selectedFloor = this.defaultLevel;
      }

      if(this.info.orgs.indexOf('SCHWARZMAN COLLEGE OF COMPUTING') > -1){
        this.selectedOrg = 'SCHWARZMAN COLLEGE OF COMPUTING';
      }


      this.mapService = new MitMapPreviewService("#mit-svg", this.palletObjects, this.showSelectedSpace);
      this.mapService.enableZoom("#zoom_in","#zoom_out","#zoom_reset");

      this.drawMap();
  },
  methods : {
    adjust(){
        this.$emit('adjusted', {
            angle:parseFloat(this.alignOverride.angle),
            x:parseFloat(this.alignOverride.x),
            y:parseFloat(this.alignOverride.y),
            level:this.selectedFloor
        });
    },
    showSelectedSpace(space){
        if(space){
            this.selectedSpace = {
                mitId: space.properties.mitId,
                mitIdShort: space.properties.mitIdShort,
                useType: space.properties.useType,
                useCategory: space.properties.useCategory,
                sqfoot: space.properties.sqfoot,
                org: space.properties.org,
                name:''
            }

            this.spaceDetailsDialog = true;
        }
        else{
            this.selectedSpace = null;
        }
    },
    autocompleteSearch(item, queryText, itemText) {
      const textMitIdShort = item.mitIdShort.toLowerCase();
      const textUse = item.useType.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textMitIdShort.indexOf(searchText) > -1  || textUse.indexOf(searchText) > -1
    },
    autocompleteChanged(item){
        if(item && item.mitIdShort){
            this.mapSpaceSelected = item.mitIdShort;
            this.selectedFloor = parseInt(item.level);
        }
        else{
            this.mapSpaceSelected = '';
        }

        this.drawMap();
    },
    palletObjectChanged(){
        this.mapService.changeCreateObject(this.palletObjectSelected);
    },
    drawMap(){
        console.log('FLOOR: ',this.selectedFloor)
        this.mapService.createMap(this.mapGeoJson, this.size.w, this.size.h, this.selectedFloor, this.selectedType, this.mapSpaceSelected, this.selectedOrg );
    }
  }
}
</script>

<style lang="scss" scoped>

  .scrollable {
   overflow-y: scroll;
   overflow-x: scroll;
  }

  .toolbar-drawing-right {
      position: absolute;
      top: 80px;
      right: 0;
    //   width: 200px;
    //   height: 360px;
      // border: 3px solid #73AD21;
  }
  // .mit-map {
  //     margin-top: -60px;
  //     margin-left: -80px;
  // }
</style>
